'use strict';

module Patersons {

    export abstract class IdentityBaseCtrl extends AbstractController {
        navigationService: Patersons.NavigationService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);

            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
        }
    }
}
